/**
 * Показ количества результатов поиска
 */

// ⛓️ CURSOR_ANCHOR:search:results-count

// Функция для показа крупных цифр с количеством результатов на 1.2 секунды
function showResultsCount(count) {
  var searchButton = document.querySelector('.search-button');
  var countElement = document.getElementById('search-results-count');
  
  if (!searchButton || !countElement) return;
  
  // Очищаем предыдущий таймер, если он есть
  if (searchButton._countTimer) {
    clearTimeout(searchButton._countTimer);
    searchButton._countTimer = null;
  }
  
  // Показываем цифры только если результатов больше 5
  if (count > 5) {
    countElement.textContent = count;
    searchButton.classList.add('show-count');
    
    // Через 1.2 секунды скрываем цифры и возвращаем иконку
    searchButton._countTimer = setTimeout(function() {
      searchButton.classList.remove('show-count');
      searchButton._countTimer = null;
    }, 1200);
  } else {
    // Если результатов 10 или меньше, не показываем цифры
    searchButton.classList.remove('show-count');
  }
}

// Экспорт для использования в других модулях results/
window.SEARCH_RESULTS_COUNT = {
  showResultsCount: showResultsCount
};

